"use client";

import { CommentReactionButton } from "../reactions/CommentReactionButton";
import React from "react";

interface CommentClapButtonProps {
  commentId: string;
  initialClapCount: number;
  initialUserClapCount: number;
  authenticated: boolean;
  className?: string;
  onClap?: (commentId: string, clapCount: number) => Promise<void>;
}

const CommentClapButton = ({
  commentId,
  initialClapCount,
  initialUserClapCount,
  authenticated,
  className,
  onClap,
}: CommentClapButtonProps) => {
  return (
    <CommentReactionButton
      commentId={commentId}
      initialClapCount={initialClapCount}
      initialUserClapCount={initialUserClapCount}
      authenticated={authenticated}
      className={className}
      onClap={onClap}
    />
  );
};

export default CommentClapButton;
